// The one place the article author is set. Change it here and every
// article byline and its structured data (JSON-LD) follow.
export const AUTHOR = {
  name: "Vanessa Challess",
  credential: "Solicitor, qualified 2003",
  role: "Founder",
  // The page that tells readers who the author is.
  path: "/founder",
};
